import styled from "styled-components"

export const StyledFeedItem = styled.div`
  position: relative;
  padding: ${({theme}) => theme.spacing.one};
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    padding: ${theme.spacing.four};
  `}
`
